import { ITermSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { getPeriodId } from './getPeriodId';
import { getServiceId } from '../../../../utils/publishTerms';
import { EServiceId } from '../../../../redux/reducers';

export function getSelectedPeriodId(terms: ITermSchema[], serviceId: EServiceId | null): number | null {
  const term = terms.find(term => serviceId === getServiceId(term.services));

  if (!term || !term.periods) {
    return null;
  }

  const { periods } = term;

  const paidPeriod = periods.find(({ isPaid }) => isPaid);
  const defaultPeriod = periods.find(({ isDefault }) => isDefault);
  const firstPeriod = periods[0];

  if (paidPeriod) {
    return getPeriodId(paidPeriod);
  }

  if (defaultPeriod) {
    return getPeriodId(defaultPeriod);
  }

  if (firstPeriod) {
    return getPeriodId(firstPeriod);
  }

  return null;
}
